import { customersApi } from '@/api';

const offersFilters = [
  {
    name: 'docNumber',
    label: 'docNumber',
    type: 'text',
    whereOperator: 'regexp',
  },
  {
    name: 'issuedAtLocal',
    label: 'issuedAt',
    type: 'dateString',
    whereOperator: '=',
  },
  {
    name: 'customerId',
    label: 'customerName',
    type: 'autocomplete',
    autocompleteSearch: async (queryString, cb) => {
      const customersResponse = await customersApi.autocompleteFetch(
        'name',
        queryString
      );
      const filteredResults = customersResponse.data.map((item) => ({
        label: item.name,
        value: item.id,
      }));
      cb(filteredResults);
    },
    whereOperator: '=',
  },
  // {
  //   name: 'enabled',
  //   label: 'activeInactive',
  //   type: 'select',
  //   whereOperator: '=',
  //   options: [
  //     { label: 'filters.active', value: 'true' },
  //     { label: 'filters.inactive', value: 'false' },
  //   ],
  // },
];

export default offersFilters;
